import { Autocomplete, FormControl, TextField } from "@mui/material";

interface MultipleSelectOptions {
  label: string;
  value: string | number;
}
interface CustomMultipleSelectProps {
  fullWidth: boolean;
  value?: readonly MultipleSelectOptions[];
  disableCloseOnSelect?: boolean;
  onChange: (value: MultipleSelectOptions[]) => void;
  label: string;
  name: string;
  error?: boolean;
  helperText?: string;
  options: MultipleSelectOptions[];
}
export default function CustomMultipleSelect({
  fullWidth,
  value,
  onChange,
  label,
  error,
  helperText,
  name,
  options,
  disableCloseOnSelect = false,
}: CustomMultipleSelectProps) {
  const selected = value;

  return (
    <FormControl
      fullWidth={fullWidth}
      sx={
        selected
          ? {
              "&": {
                mt: "3px",
              },
            }
          : {
              "&": {
                py: "10px",
              },
            }
      }
    >
      <Autocomplete
        options={options}
        disableCloseOnSelect={disableCloseOnSelect}
        getOptionLabel={(option: MultipleSelectOptions) => option.label}
        multiple
        isOptionEqualToValue={(option, value) => option.label === value.label}
        value={value ? [...value] : []}
        onChange={(e, value) => onChange(value as MultipleSelectOptions[])}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            label={label}
            variant="standard"
            error={!!error}
            helperText={helperText}
          />
        )}
      />
    </FormControl>
  );
}
